module.exports = __webpack_public_path__ + "img/banner-maskex4.27efd830.webp";